<template>

    <div id="contacts" class="d-flex justify-content-start align-items-center py-5">
        <b-container>
            <b-row class="d-flex justify-content-center align-items-center">
                <b-col cols="12" lg="6" class="d-flex justify-content-center align-items-center">
                    <article class="article">
                        <h4>Entre em Contato</h4>
                        <p>Entre em contato conosco por direct, por telefone
                        ou preencha o formulário para receber uma consulta
                        gratuita de nossa equipe dedicada.</p>
                        <figure class="d-flex justify-content-start align-items-center my-5 figureStyle" style="gap: 1rem">
                            <img src="@/assets/page/contacts/perfil.png" alt="Foto de Perfil">
                            <div class="d-flex justify-content-center align-items-start flex-column" style="gap: 1rem">
                                <p class="d-flex align-items-center" style="gap: 1rem"><img src="@/assets/page/contacts/localization.png" alt="">Diretor</p>
                                <h4>Lucas Frazatto</h4>
                            </div>
                        </figure>
                        <div class="d-flex justify-content-center align-items-start flex-column my-2 contactBox" >
                            <p class="d-flex align-items-center"><img src="@/assets/page/contacts/phone.png" alt="Ícone que representa um telefone">Telefone</p>
                            <h5><a href="tel:+556696924173" target="_blank">(66) 9 9692-4173</a></h5>
                        </div>
                        <div class="d-flex justify-content-center align-items-start flex-column contactBox">
                            <p class="d-flex align-items-center"><img src="@/assets/page/contacts/mail.png" alt="Ícone que representa um email">Email</p>
                            <h5><a href="mailto: comercial@frazattologistica.com.br" target="_blank">comercial@frazattologistica.com.br</a></h5>
                        </div>
                    </article>
                </b-col>
                <b-col cols="12" lg="6" class="d-flex justify-content-center align-items-center m-0">
                    <article class="article mail-box">
                        <Form />
                    </article>
                </b-col>
            </b-row>
        </b-container>
    </div>

</template>

<script>
import Form from '../users/Form.vue';

    export default {
        components: {Form}
    }

</script>

<style scoped lang="scss">
    #contacts {
        background-image: url("@/assets/page/contacts/background.png");
        background-color: var(--primaryColorDark);
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        min-height: 100vh;
        position: relative;
        z-index: 0;

        &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.6);
        }

        .article {
            min-height: 637px;
            color: var(--white);
            background-color: var(--primaryColor);
            z-index: 1;
            padding: 2rem;
            border-radius: 1rem;
            gap: 3rem !important;
            border: 5px solid var(--primaryColor);
            margin-bottom: 1rem;

            p {
                margin: 0;
            }

            h4 {
                font-weight: bold;
            }

            a {
                color: var(--white);
                text-decoration: none;
                font-weight: bold;
                font-size: 1.2rem;
                transition: color 0.3s ease;


                &:hover {
                    color: var(--secondaryColor); 
                }
            }
            
        }
    }

    .mail-box {
        background-color: var(--primaryColorDark) !important;
        width: 100%;
    }

    @media screen and (max-width: 500px){
        #contacts {
            text-align: center !important;
        }

        .figureStyle {
            flex-direction: column;
            
            p {
                width: 100%;
                justify-content: center;
            }

        }

        .contactBox {
            align-items: center !important;
        }
    }

</style>